import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, Fragment, renderList, createCommentVNode, normalizeClass, createBlock, unref, createTextVNode } from "vue";
import ProductBadge from "../ProductBadge/ProductBadge.mjs";
const _hoisted_1 = {
  key: 0,
  class: "curated-outfit"
};
const _hoisted_2 = {
  key: 0,
  class: "curated-outfit__heading"
};
const _hoisted_3 = {
  class: "curated-outfit__heading-top"
};
const _hoisted_4 = {
  class: "curated-outfit__heading-bottom"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "curated-outfit__author-details"
};
const _hoisted_7 = {
  class: "curated-outfit__author-name"
};
const _hoisted_8 = {
  class: "curated-outfit__author-desc"
};
const _hoisted_9 = ["href", "onClick"];
const _hoisted_10 = {
  key: 1,
  class: "curated-outfit__badge"
};
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  class: "curated-outfit__details"
};
const _hoisted_13 = {
  class: "curated-outfit__brand"
};
const _hoisted_14 = {
  class: "curated-outfit__name"
};
const _hoisted_15 = {
  class: "curated-outfit__price-map-wrapper"
};
const _hoisted_16 = {
  class: "curated-outfit__price-map"
};
const _hoisted_17 = {
  key: 0,
  class: "curated-outfit__compare"
};
const _hoisted_18 = {
  class: "curated-outfit__compare--value"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CuratedOutfit",
  props: {
    styles: {},
    data: {}
  },
  emits: ["metricsClick"],
  setup(__props) {
    const formatPrice = (price) => price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const isStyleOnSale = (stylePrice) => stylePrice.minPrice.sale && stylePrice.maxPrice.sale;
    const showRange = (stylePrice) => stylePrice.minPrice.value !== stylePrice.maxPrice.value;
    const showCompare = (stylePrice) => isStyleOnSale(stylePrice) && stylePrice.minPrice.value < stylePrice.minCompareAt.value && !!stylePrice.minCompareAt.value;
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return ((_a = _ctx.styles) == null ? void 0 : _a.length) ? (openBlock(), createElementBlock("div", _hoisted_1, [((_b = _ctx.data) == null ? void 0 : _b.headingTop) && ((_c = _ctx.data) == null ? void 0 : _c.headingBottom) ? (openBlock(), createElementBlock("div", _hoisted_2, [createElementVNode("h2", null, [createElementVNode("span", _hoisted_3, toDisplayString(_ctx.data.headingTop), 1), _cache[0] || (_cache[0] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, " - ", -1)), createElementVNode("span", _hoisted_4, toDisplayString(_ctx.data.headingBottom), 1)]), (openBlock(true), createElementBlock(Fragment, null, renderList((_d = _ctx.data) == null ? void 0 : _d.authors, (author, index) => {
        return openBlock(), createElementBlock(Fragment, null, [(author == null ? void 0 : author.imageSrc) && (author == null ? void 0 : author.name) && (author == null ? void 0 : author.description) ? (openBlock(), createElementBlock("div", {
          key: index,
          class: "curated-outfit__author"
        }, [createElementVNode("img", {
          src: author.imageSrc,
          loading: "lazy",
          class: "curated-outfit__author-img",
          alt: author.name
        }, null, 8, _hoisted_5), createElementVNode("div", _hoisted_6, [createElementVNode("p", _hoisted_7, toDisplayString(author.name), 1), createElementVNode("p", _hoisted_8, toDisplayString(author.description), 1)])])) : createCommentVNode("", true)], 64);
      }), 256))])) : createCommentVNode("", true), createElementVNode("ul", {
        class: normalizeClass(["curated-outfit__styles", {
          "curated-outfit__styles--staggered": _ctx.styles.length % 2 !== 0
        }])
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.styles, (item) => {
        var _a2;
        return openBlock(), createElementBlock("li", {
          key: item.styleId,
          class: "curated-outfit__item"
        }, [createElementVNode("a", {
          href: item.link,
          class: "curated-outfit__link",
          onClick: ($event) => _ctx.$emit("metricsClick", {
            linkName: `shop the look_${item.styleId}`
          })
        }, [((_a2 = item.badges) == null ? void 0 : _a2.length) > 0 ? (openBlock(), createBlock(unref(ProductBadge), {
          key: 0,
          badge: item.badges[0],
          "enable-click": false,
          class: "curated-outfit__badge"
        }, null, 8, ["badge"])) : (openBlock(), createElementBlock("div", _hoisted_10)), createElementVNode("img", {
          src: `/media/product/${item.styleId}`,
          class: "curated-outfit__image",
          alt: item.name,
          lazy: "true"
        }, null, 8, _hoisted_11), createElementVNode("div", _hoisted_12, [createElementVNode("h3", null, [createElementVNode("span", _hoisted_13, toDisplayString(item.brand.name), 1), createElementVNode("span", _hoisted_14, toDisplayString(item.name), 1)]), createElementVNode("div", _hoisted_15, [createElementVNode("span", _hoisted_16, [createElementVNode("span", {
          class: normalizeClass(["curated-outfit__price-value", {
            "curated-outfit__price-value--sale": item.stylePrice.minPrice.sale
          }])
        }, " $" + toDisplayString(formatPrice(item.stylePrice.minPrice.value)), 3), showRange(item.stylePrice) ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["curated-outfit__price-range", {
            "curated-outfit__price-range--sale": item.stylePrice.maxPrice.sale
          }])
        }, [_cache[1] || (_cache[1] = createTextVNode(" – ")), _cache[2] || (_cache[2] = createElementVNode("span", {
          class: "pdp-sr-only"
        }, "to", -1)), createTextVNode(" $" + toDisplayString(formatPrice(item.stylePrice.maxPrice.value)), 1)], 2)) : createCommentVNode("", true)]), !showRange(item.stylePrice) && showCompare(item.stylePrice) ? (openBlock(), createElementBlock("span", _hoisted_17, [_cache[3] || (_cache[3] = createElementVNode("span", {
          class: "pdp-sr-only"
        }, "Compared to ", -1)), createElementVNode("span", _hoisted_18, " $" + toDisplayString(formatPrice(item.stylePrice.maxCompareAt.value)), 1)])) : createCommentVNode("", true)])])], 8, _hoisted_9)]);
      }), 128))], 2)])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CuratedOutfit2.mjs.map
